/* PokéVault — search.js: zoeksuggesties terwijl je typt. */
(function () {
  'use strict';

  var theme = window.theme || {};
  var routes = theme.routes || {};

  var form = document.querySelector('[data-predictive-form]');
  var input = document.querySelector('[data-predictive-input]');
  var results = document.querySelector('[data-predictive-results]');
  if (!form || !input || !results) return;

  var timer;
  var controller;
  var cache = {};

  function render(html) {
    results.innerHTML = html;
  }

  function search(term) {
    if (cache[term]) { render(cache[term]); return; }
    if (controller) controller.abort();
    controller = new AbortController();
    var url = (routes.predictiveSearch || '/search/suggest') +
      '?q=' + encodeURIComponent(term) +
      '&resources[type]=product,collection,page' +
      '&resources[limit]=6' +
      '&section_id=predictive-search';
    fetch(url, { signal: controller.signal })
      .then(function (response) { return response.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var inner = doc.querySelector('.predictive__inner');
        var markup = inner ? inner.outerHTML : '';
        cache[term] = markup;
        render(markup);
      })
      .catch(function (error) {
        if (error && error.name === 'AbortError') return;
        render('');
      });
  }

  input.addEventListener('input', function () {
    var term = input.value.trim();
    clearTimeout(timer);
    if (term.length < 2) { render(''); return; }
    timer = setTimeout(function () { search(term); }, 220);
  });

  input.addEventListener('keydown', function (event) {
    if (event.key !== 'ArrowDown') return;
    var first = results.querySelector('a');
    if (first) { event.preventDefault(); first.focus(); }
  });

  results.addEventListener('keydown', function (event) {
    if (event.key !== 'ArrowUp') return;
    var links = Array.prototype.slice.call(results.querySelectorAll('a'));
    if (links.indexOf(document.activeElement) === 0) { event.preventDefault(); input.focus(); }
  });
})();
